<div class="searchable-select-wrapper" #dropdown>
  <div
    class="searchable-select-trigger"
    [class.disabled]="disabled"
    [class.open]="isOpen"
    [class.has-value]="selectedOption"
    (click)="toggleDropdown()"
    (keydown)="onKeyDown($event)"
    [attr.tabindex]="disabled ? -1 : 0"
    role="combobox"
    [attr.aria-expanded]="isOpen"
    [attr.aria-haspopup]="true"
  >
    <span class="select-value" [class.placeholder]="!selectedOption">
      <ng-container *ngIf="selectedOption && selectedOption.label; else placeholderTemplate">
        {{ selectedOption.label }}
      </ng-container>
      <ng-template #placeholderTemplate>
        {{ placeholder }}
      </ng-template>
    </span>
    <div class="select-actions">
      <button
        *ngIf="allowClear && selectedOption && !disabled"
        type="button"
        (click)="clearSelection($event)"
        (mousedown)="$event.preventDefault()"
        class="clear-button"
        aria-label="Clear selection"
        title="Clear selection"
      >
        <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12" />
        </svg>
      </button>
      <svg class="w-4 h-4 arrow-icon" [class.rotated]="isOpen" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 9l-7 7-7-7" />
      </svg>
    </div>
  </div>

  <div class="dropdown-menu" *ngIf="isOpen" [class.show]="isOpen">
    <div class="search-input-wrapper">
      <svg class="search-icon" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" />
      </svg>
      <input
        #searchInput
        type="text"
        [value]="searchTerm"
        (input)="onSearchInput($event)"
        [placeholder]="searchPlaceholder"
        class="search-input"
        autofocus
      />
      <div *ngIf="isSearching" class="search-loading">
        <svg class="animate-spin h-4 w-4" fill="none" viewBox="0 0 24 24">
          <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
          <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
        </svg>
      </div>
    </div>
    
    <div class="options-list" *ngIf="filteredOptionsList.length > 0">
      <div
        *ngFor="let option of filteredOptionsList; let i = index"
        [id]="'option-' + i"
        class="option-item"
        [class.highlighted]="i === highlightedIndex"
        [class.disabled]="option.disabled"
        [class.selected]="isOptionSelected(option)"
        (click)="selectOption(option, $event)"
        (mousedown)="$event.preventDefault()"
        (mouseenter)="highlightedIndex = i"
      >
        <span class="option-label">{{ option.label }}</span>
        <svg *ngIf="isOptionSelected(option)" class="w-4 h-4 check-icon" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 13l4 4L19 7" />
        </svg>
      </div>
    </div>
    
    <div class="no-results" *ngIf="filteredOptionsList.length === 0 && !isSearching">
      <p *ngIf="searchCallback">{{ searchTerm ? 'No results found' : emptySearchHint }}</p>
      <p *ngIf="!searchCallback">No results found</p>
    </div>
  </div>
</div>
